import React, { useMemo } from 'react';

const SeasonWinLossTrend = ({ games }) => {
  const recentGames = useMemo(() => {
    if (!games?.length) return [];
    const finished = games
      .filter(g => g.status?.abstractGameState === 'Final' && g.teams)
      .slice(-20);
    return finished.map(g => {
      const bosHome = g.teams.home.team.id === 111;
      const bosScore = bosHome ? g.teams.home.score : g.teams.away.score;
      const oppScore = bosHome ? g.teams.away.score : g.teams.home.score;
      const won = Number(bosScore) > Number(oppScore);
      const opp = bosHome ? g.teams.away.team.abbreviation : g.teams.home.team.abbreviation;
      return { won, bosScore, oppScore, opp, gamePk: g.gamePk };
    });
  }, [games]);

  if (!recentGames.length) return null;

  const wins = recentGames.filter(g => g.won).length;
  const losses = recentGames.length - wins;

  return (
    <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
      <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)] flex items-center justify-between">
        <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Recent Results</span>
        <span className="text-[9px] text-[#a9c9b1] font-bold uppercase tracking-widest">
          Last {recentGames.length} · <span className="text-[#a9c9b1]">{wins}W</span> <span className="text-[#c4333e]">{losses}L</span>
        </span>
      </div>
      <div className="p-3">
        <div className="flex gap-1 flex-wrap mb-3">
          {recentGames.map((g, i) => (
            <div key={i} title={`${g.won ? 'W' : 'L'} vs ${g.opp} ${g.bosScore}-${g.oppScore}`}
              className={`w-6 h-6 flex items-center justify-center text-[9px] font-black border transition-all cursor-default ${g.won
                ? 'bg-[rgba(101,141,113,0.3)] border-[#658d71] text-[#a9c9b1]'
                : 'bg-[rgba(196,51,62,0.2)] border-[rgba(196,51,62,0.5)] text-[#c4333e]'}`}>
              {g.won ? 'W' : 'L'}
            </div>
          ))}
        </div>
        <div className="flex gap-3 flex-wrap">
          {recentGames.slice(-5).map((g, i) => (
            <div key={i} className="flex flex-col items-center gap-0.5">
              <span className="text-[8px] text-[#658d71] font-bold uppercase">{g.opp}</span>
              <span className={`text-[10px] font-black tabular-nums ${g.won ? 'text-[#a9c9b1]' : 'text-[#c4333e]'}`}>
                {g.bosScore}-{g.oppScore}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SeasonWinLossTrend;